import Link from 'next/link';

import PressLogos from '@components/homepage/press-logos';
import TrustpilotRating from '@components/quiz/shared/TrustpilotRating';

const HEADING_ID = 'trusted-by-managers-heading';
const TEAM_REVEALS_PATH = '/category/team-reveal';

// The review carousel the site already runs, limited to 4 and 5 star English
// reviews by TrustpilotRating. Its height is the template's own, fixed so the
// iframe can't shift the page as it loads.
const TRUSTPILOT_CAROUSEL_TEMPLATE_ID = '54ad5defc6454f065c28af8b';
const TRUSTPILOT_CAROUSEL_HEIGHT = '240px';
const TRUSTPILOT_CAROUSEL_WIDTH = '100%';

const TrustedByManagers = () => (
  <section aria-labelledby={HEADING_ID} className="bg-white">
    <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 lg:py-16">
      <h2
        id={HEADING_ID}
        className="font-sans text-2xl font-bold leading-8 text-landing-ink lg:text-[28px] lg:leading-9"
      >
        Trusted by managers who play to win
      </h2>
      <div className="mt-6 grid gap-5 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)] lg:items-stretch">
        <div className="min-h-[256px] overflow-hidden rounded-xl border border-landing-hairline bg-white p-2">
          <TrustpilotRating
            templateId={TRUSTPILOT_CAROUSEL_TEMPLATE_ID}
            height={TRUSTPILOT_CAROUSEL_HEIGHT}
            width={TRUSTPILOT_CAROUSEL_WIDTH}
          />
        </div>
        <div className="flex flex-col justify-between gap-6 rounded-xl bg-landing-ink p-6">
          <div>
            <p className="font-open-sans text-[11px] font-bold uppercase tracking-[.12em] text-primary-300">
              Our writers
            </p>
            <p className="mt-3 font-sans text-lg font-semibold leading-7 text-white">
              Team reveals from all-time world number one Ben Crellin and the
              best managers in the game.
            </p>
            <Link
              href={TEAM_REVEALS_PATH}
              className="mt-4 inline-flex font-open-sans text-sm font-semibold text-primary-300 underline-offset-4 hover:underline"
            >
              See this week&apos;s team reveals
            </Link>
          </div>
          <PressLogos tone="light" />
        </div>
      </div>
    </div>
  </section>
);

export default TrustedByManagers;
